// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GamesMonth_wrapper__93y_f","content":"GamesMonth_content__VdtOX","header":"GamesMonth_header__yMiyt","title":"GamesMonth_title__mD2OM","link":"GamesMonth_link__cwhBZ"};